import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { BreakfastAndWifiDisclaimer } from './breakfast-wifi-disclaimer';
import { Messaging } from 'components/common/messaging';
import { SearchResultsReviews } from './search-results-reviews';

interface ListingCommonSectionProps {
  routeStoreGoBack: () => void;
}

export const ListingCommonSection: React.FC<ListingCommonSectionProps> = ({ routeStoreGoBack }) => (
  <>
    <ErrorBoundary label="hotel.search.listing.messaging">
      <Messaging />
    </ErrorBoundary>
    <BreakfastAndWifiDisclaimer handleBack={routeStoreGoBack} />
    <ErrorBoundary label="hotel.search.listing.reviews">
      <SearchResultsReviews />
    </ErrorBoundary>
  </>
);
ListingCommonSection.displayName = 'ListingCommonSection';
